import type { App } from 'vue'
import { CHAVE_OPERACOES_CATALOGO_PERFIL_DE_PERMISSAO } from '@next/modulos/governanca/perfil-de-permissao/catalogo/apresentacao/catalogo-perfil-de-permissao.injecao'
import type { OperacoesCatalogoPerfilDePermissao } from '@next/modulos/governanca/perfil-de-permissao/catalogo/catalogo-perfil-de-permissao.tipos'
import { criarCasoDeUsoListarOpcoesPerfilDePermissao } from '@next/modulos/governanca/perfil-de-permissao/catalogo/listar-opcoes/listar-opcoes-perfil-de-permissao'
import { ListarOpcoesPerfilDePermissaoRepositorioHttp } from '@next/modulos/governanca/perfil-de-permissao/catalogo/listar-opcoes/listar-opcoes-perfil-de-permissao.repositorio-http'
import type { InfraestruturaAplicacao } from '../criar-infraestrutura'
export const comporCatalogoPerfilDePermissao = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoPerfilDePermissao => {
  const repositorio = new ListarOpcoesPerfilDePermissaoRepositorioHttp(infraestrutura.httpCondominio)
  return { listarOpcoes: criarCasoDeUsoListarOpcoesPerfilDePermissao(repositorio.executar) }
}
export const instalarPerfilDePermissao = (app: App, infraestrutura: InfraestruturaAplicacao): void => {
  app.provide(CHAVE_OPERACOES_CATALOGO_PERFIL_DE_PERMISSAO, comporCatalogoPerfilDePermissao(infraestrutura))
}
